export default __webpack_public_path__ + "static/media/jackpot.c200a59b.png";